import {
  file,
  file1,
  file2,
  file3,
  javascript,
  typescript,
  html,
  css,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  logo12,
  logo13,
  reactjs,
  redux,
  tailwind,
  nodejs,
  mongodb,
  git,
  soil,
  SV,
  gtp1, // ✅ Eliminado gtp2
  figma,
  docker,
  meta,
  starbucks,
  parsec,
  tesla,
  shopify,
  carrent,
  jobit,
  tripguide,
  threejs,
  web,
} from "../assets";

export const navLinks = [
  {
    id: "about",
    title: "nav.about", // Clave de traducción para "Sobre Nosotros"
  },
  {
    id: "work",
    title: "nav.work", // Clave de traducción para "Proyectos"
  },
  {
    id: "contact",
    title: "nav.contact", // Clave de traducción para "Contacto"
  },
];

const servicios = [
  {
    title: "servicios.projecte", // Clave para "PROJECTE"
    icon: file,
    link: "/projecte",
  },
  {
    title: "servicios.mostreig", // Clave para "MOSTREIG"
    icon: file1,
    link: "/steamcat",
  },
  {
    title: "servicios.centres", // Clave para "CENTRES"
    icon: file2,
    link: "/map",
  },
  {
    title: "servicios.instruccions", // Clave para "INSTRUCCIONS"
    icon: file3,
    link: "/instructions",
  },
];

const technologies = [
  { name: "HTML 5", icon: logo1 },
  { name: "CSS 3", icon: logo2 },
  { name: "JavaScript", icon: logo3 },
  { name: "TypeScript", icon: logo4 },
  { name: "React JS", icon: logo5 },
  { name: "Redux Toolkit", icon: logo6 },
  { name: "Tailwind CSS", icon: logo7 },
  { name: "Node JS", icon: logo8 },
  { name: "MongoDB", icon: logo9 },
  { name: "Three JS", icon: logo10 },
  { name: "git", icon: logo11 },
  { name: "figma", icon: logo12 },
  { name: "docker", icon: logo13 },
];

const experiences = [
  {
    title: "experience.first.title",
    company_name: "experience.first.company",
    icon: parsec,
    iconBg: "#383E56",
    date: "experience.first.date",
    points: [
      "experience.first.point1",
      "experience.first.point2",
      "experience.first.point3",
      "experience.first.point4",
    ],
  },
  {
    title: "experience.second.title",
    company_name: "experience.second.company",
    icon: parsec,
    iconBg: "#E6DEDD",
    date: "experience.second.date",
    points: [
      "experience.second.point1",
      "experience.second.point2",
      "experience.second.point3",
    ],
  },
  {
    title: "experience.third.title",
    company_name: "experience.third.company",
    icon: parsec,
    iconBg: "#383E56",
    date: "experience.third.date",
    points: [
      "experience.third.point1",
      "experience.third.point2",
      "experience.third.point3",
    ],
  },
  {
    title: "experience.fourth.title",
    company_name: "experience.fourth.company",
    icon: parsec,
    iconBg: "#E6DEDD",
    date: "experience.fourth.date",
    points: [
      "experience.fourth.point1",
      "experience.fourth.point2",
      "experience.fourth.point3",
    ],
  },
];

const testimonials = [
  {
    testimonial: "testimonials.emily.text",
    name: "testimonials.emily.name",
    designation: "testimonials.emily.designation",
    company: "testimonials.emily.company",
    image: "https://randomuser.me/api/portraits/women/9.jpg",
  },
  {
    testimonial: "testimonials.marc.text",
    name: "testimonials.marc.name",
    designation: "testimonials.marc.designation",
    company: "testimonials.marc.company",
    image: "https://randomuser.me/api/portraits/men/10.jpg",
  },
  {
    testimonial: "testimonials.sophia.text",
    name: "testimonials.sophia.name",
    designation: "testimonials.sophia.designation",
    company: "testimonials.sophia.company",
    image: "https://randomuser.me/api/portraits/women/11.jpg",
  },
];

const projects = [
  {
    name: "projects.exploration.name",
    description: "projects.exploration.description",
    tags: [
      { name: "projects.exploration.tags.educacion", color: "blue-text-gradient" },
      { name: "projects.exploration.tags.cienciaCiutadana", color: "green-text-gradient" },
      { name: "projects.exploration.tags.soil", color: "pink-text-gradient" },
    ],
    image: soil,
    source_code_link: "https://github.com/",
  },
  {
    name: "projects.biodiversity.name",
    description: "projects.biodiversity.description",
    tags: [
      { name: "projects.biodiversity.tags.biodiversitat", color: "blue-text-gradient" },
      { name: "projects.biodiversity.tags.investigacion", color: "green-text-gradient" },
      { name: "projects.biodiversity.tags.ods", color: "pink-text-gradient" },
    ],
    image: gtp1,
    source_code_link: "https://github.com/",
  },
  {
    name: "projects.community.name",
    description: "projects.community.description",
    tags: [
      { name: "projects.community.tags.accioLocal", color: "blue-text-gradient" },
      { name: "projects.community.tags.impacteGlobal", color: "green-text-gradient" },
      { name: "projects.community.tags.regeneracio", color: "pink-text-gradient" },
    ],
    image: SV,
    source_code_link: "https://google.com/",
  },
];

export { servicios, technologies, experiences, testimonials, projects };
